import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import $ from 'jquery';
import LeftScriptParticipant from "./LeftScriptParticipant";
import FooterScriptParticipant from "./FooterScriptParticipant";
import setAuthToken from "../../utils/setAuthToken";
import Util from "../../streaming/Util";
import SessionDataStore from "../../streaming/SessionDataStoreController";
import classnames from "classnames";
import Const from "../../constants/Constants";
import axios from "axios";
import ActivityList from "./ActivityList";
import { loadWhiteboard } from '../../utils/whiteboard';
import SupportContainer from '../home/SupportContainer';
import { updateHeartRate } from '../../utils/updateHeartRate';
import whiteboard from "../../utils/whiteboardNew";
import playerFunctions from "../../utils/playerFunctions";
import FmPlayer from "./FmPlayer";
import audioPlay from "../../utils/audioPlay";

import { isChrome as chrome, isSafari as safari, isBrowser as browser, isFirefox as ff, osName as osname, fullBrowserVersion as fbrowserversion, browserName, deviceType, isMobileOnly as mobileOnly, isTablet as tablet, isIPad13 as ipad13, isAndroid as android} from "react-device-detect";
class Ondemand extends Component {

  constructor(props) {
    super(props);
	
    this.state = {
      sessionScript: 0,
      isScriptAvailable: false,
      currentUserData: JSON.parse(localStorage.getItem('userData')),
      pause:true,
      player:null,
      progressBar:0,
      muted:false,
      videoDuration:false,
      can_change_duration:false,
      videoDurationCalculated:false,
      manualPaused:false,
      pauseScript:false,
      hideLocalStream:false,
      streamError:true,
  	  watermarkLevel: false,
  	  whiteboardLoaded: window['userWhiteboard'] && window['userWhiteboard'][JSON.parse(localStorage.getItem('userData')).id] ? true : false,
  	  videosSwapped: false,
  	  roomTimerStarted: false,
  	  supportPageName: 'On Demand',
  	  supportPageApi: '/ondemand',
  	  userTypeFaqs: 1,
	  roomSetupRunning: false,
	  resolutionChosen: '',
	  streamStatus: false,
	  showPlayer: false,
	  videoStopedStatus: false,
	  setupStep: 0,
	  setupStepName: 'Device Settings',
	  watchAppPopupShown: false,
	  shownWatchAppScreen: 1,
	  roomSetupStep: 1,
	  roomSetupTitle: 'Augmented Reality Requirements',
	  roomSetupText: '<ol><li>After Completing Camera & Room Setup, Do Not Move Your Camera.</li><li>Your Feet And Your Shoulders Must Be Visible In the Camera.</li><li>Do Not Point Camera Towards A Window With Sunlight.</li><li>Do Not Walk Towards the Camera During Virtual Equipment Exercises.</li></ol>',
	  roomSetupTitleNames: ['Augmented Reality Requirements', 'Stand in the marked area', 'Capturing', 'Done', 'Done', ''],
	  roomSetupTextNames: ['<ol><li>After Completing Camera & Room Setup, Do Not Move Your Camera.</li><li>Your Feet And Your Shoulders Must Be Visible In the Camera.</li><li>Do Not Point Camera Towards A Window With Sunlight.</li><li>Do Not Walk Towards the Camera During Virtual Equipment Exercises.</li></ol>', '', '', '', '', ''],
	  roomSetupButtonText: 'Continue',
	  roomSetupSecondButton: '',
	  roomSetupImageNames: ['', '', 'room_setup_loader', 'done_check', 'done_check', ''],
	  roomSetupButtonTextNames: ['Continue', 'Skip', '', '', '', ''],
	  roomSetupImage: '',
	  innerHold: false,
	  innerHoldSteps: [false, false, true, true, true, false],
	  allCameraPermissionsTurnedOff: false,
	  dontHaveAnyCam: false,
	  showContinueButton: false,
	  boxJumpWidth: 14,
	  boxJumpHeight: 14,
	  boxingCirclePosition: 1,
	  hostWhiteboardLoaded: false,
	  checkEndVideo: false,
	  hiddenCaluclatingAR: true,
	  dontShowInfo: "Don't show this again",
	  recalibrationPopup: false
    };

    this.sessionDataStore = SessionDataStore.getInstance();
    this.syncArr = [];
    this.syncTimer = null;
    this.recordingStartTimeActual = null;
    this.recordingStartTime = null;
    this.recordingEndTime = null;
    this.duration = 0;
    this.deadline = 0;
    this.AgoraRTM = window.AgoraRTM;
    this.newclient = window.newclient;
    this.buffering = false;
    this.emojiArr = [];
    this.bpmArr = [];
    this.platformDetails = null;
  	this.zeroTimer = null;
  	this.zeroTimeout = null;
  	this.zeroCounter = 15;
  	this.roomSetupFailed = false;
    this.updateHeartRate = updateHeartRate.bind(this);
    this.lastTime = null;
    this.localStream = null;
    this.cameraId = null;
	this.clickedOnSkip = false;
	this.foundStartRtm = false;
	this.startTimeRTM = null;
	this.videoStopped = false;
	window['onDemand'] = true;
	window['currentUserData'] = this.state.currentUserData;
	this.userWhiteboard = '';
	this.hostUserWhiteboard = '';
	window['userWhiteboard'] = window['userWhiteboard'] ? window['userWhiteboard'] : {};
	this.playerFunctions = new playerFunctions();
	window['playerFunctions'] = this.playerFunctions;
	window['playPlayerDemand'] = this.playPlayer;
	window['stopPlayerDemand'] = this.stopPlayer;
	window['currentStationId'] = '';
	window['showPlayerDemand'] = this.showPlayerDemand;
	window['checkRoomSetup'] = this.checkRoomSetup;
	window['workoutConePlacing'+this.state.currentUserData.id] = {};
	window.roomSetupNextStep = this.roomSetupNextStep;
	window.callTiltMessage = this.callTiltMessage;
	window.showSkipAndRetry = this.showSkipAndRetry;
	window.showHideRoomSetup = this.showHideRoomSetup;
	var soundPlay = window.soundPlay ? window.soundPlay : new audioPlay();
	window.soundPlay = soundPlay;
	window.showSkipAndTryAgain = this.showSkipAndTryAgain;
	window.callMediaTilt = this.callMediaTilt;
	window['onDemandWASDone'] = false;
	window.Util = Util;
	window.sessionDataStore = this.sessionDataStore;
	window.startPauseVirtual = this.startPauseVirtual;
	window.calculatingAR = this.calculatingAR;
	window.disableCalculatingAR = this.disableCalculatingAR;
	window.loadPreLoadedVideo = this.loadPreLoadedVideo;
	this.rtmCodes = {};
  }
  
	showPlayerDemand = (mod) => {
		this.setState({showPlayer: mod});
	}

  startSlideIndex = () =>{
    this.setState((state) => ({ can_change_duration: true }));

    if (this.state.isScriptAvailable) {
      clearInterval(this.syncTimer);
      this.setState({pause: true});
      this.state.player.pause();
    }
  }

  endSlideIndex = () =>{
    this.setState((state) => ({ can_change_duration: false }));  
  }

  onLogoutClick = e => {
	
	if ( window['stopPlayer'] )
		{
			window['stopPlayer']();
		}
	
	window['hasConeScript'] = false;
	window['mediaPipeFirstTime'] = false;
	window['onDemandWASDone'] = false;
	window['deviceNotSupported'] = false;
	
	if ( window['userWhiteboard'][this.state.currentUserData.id] )
		{
			clearInterval(window['userWhiteboard'][this.state.currentUserData.id].updateInterval);
			if ( window['userWhiteboard'][this.state.currentUserData.id].perMinuteInterval ) { clearInterval(window['userWhiteboard'][this.state.currentUserData.id].perMinuteInterval); }
			
			window['userWhiteboard'][this.state.currentUserData.id].soundPlay.stopAudio();
			
			window.removeUserWhiteboard(parseInt(this.state.currentUserData.id));
		}
	window['userWhiteboard'] = {};
	this.endVideo();
	this.newclient.logout();
	setAuthToken(false);
	
	if ( !this.state.pause )
		{
			this.playPause();
		}		
	
	if ( window['electron'] && window['electronPowerSaver'] && window['electronPowerSaver'].stop )
		{
			if ( window['electronPowerSaverId'] ) { window['electronPowerSaver'].stop(window['electronPowerSaverId']); }
		}
		
	this.props.history.push('/home#onDemand');
	window['onDemand'] = false;
	if ( window['eventHR'] )
		{
			window['eventHR'].close();
			window['eventHR'] = false;
		}
	this.stopStream();	
	this.newclient = undefined;
	document.getElementById("video-element").removeEventListener("timeupdate", this.updateProgressBar, false);
  };
  
	stopStream=()=>{
		if ( this.localStream )
			{
				this.localStream.getVideoTracks().forEach(function(track) {
				  track.stop();
				});
			}
		
	}
  
  finishHeightOnDemand = () => {
	  window['measuringProcess'+this.state.currentUserData.id] = false;
	  window['viewCaptured'+this.state.currentUserData.id] = true;
	  //$('#movedEquipmentDem').removeClass('d-none');
	  window['hostStartedEquipment'+this.state.currentUserData.id] = false;
	  window['didAnimationBag'+this.state.currentUserData.id] = false;
  }
  
  playPause = (fPlay) => {
	  if ( this.state.roomSetupRunning ) { return false; }
	  
      if (this.state.pause === false && fPlay !== 'forcePlay' ) {
		  console.log('playPause playing - do pause');
		  
          this.setState({pause: true});
          this.state.player.pause();

          if (this.state.isScriptAvailable) {
              clearInterval(this.syncTimer);
              if ( !window.isPaused ) {
                  this.setState({manualPaused: true});
                  window.isPaused = true;
              }
          }

          let addObject = {"userId": this.state.currentUserData.id, "event": "video", "eventType": "pause", "details": JSON.stringify({"onDemandId": this.state.currentUserData.sessionData.ondemandId, "platform": this.platformDetails}), "timestamp": Util.getCurrentTimestamp()};
          this.sessionDataStore.addSessionData(addObject);
      } else {
		  console.log('playPause pause - do play');
          this.setState({pause: false, videoStopedStatus: false, checkEndVideo: false});
		  this.videoStopped = false;
          this.state.player.play();

          let addObject = {"userId": this.state.currentUserData.id, "event": "video", "eventType": "play", "details": JSON.stringify({"onDemandId": this.state.currentUserData.sessionData.ondemandId, "platform": this.platformDetails}), "timestamp": Util.getCurrentTimestamp()};
          this.sessionDataStore.addSessionData(addObject);
		  
          if ( this.state.isScriptAvailable ) {
			  
			  window.isPaused = false;
			  //window.countDown();
			  if ( this.state.videoStopedStatus || this.state.checkEndVideo )
				  {
					  //window.countDown();
				  }
				  
              if ( this.state.manualPaused === true ) {

				  if ( window['userWhiteboard'] && window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].globalActType != "" )
					  {
						  window['userWhiteboard'][this.state.currentUserData.id].doActivityEvents('activityStarted');
					  }
				  //this.setState({manualPaused: false});
              }

              if (this.state.progressBar.value == 100) {
                  this.resetScript();
              }
          }
      }
  }

  endVideo = () => {
      console.log('video ended======');
      if (this.state.pause === false) {
          this.setState({pause: true});
          this.state.player.pause();
      } else {
          this.setState({pause: false});
          this.state.player.play();
      }	  
	  this.setState({checkEndVideo: true});
      this.state.progressBar.value = 100;
      clearInterval(this.syncTimer);
	  
	  if ( this.state.whiteboardLoaded )
		{
			$('#canvasWrap').addClass('d-none');
			$('.on_demand_stats').addClass("d-none");
			window.pauseVirtualActivityStarted = false;
			window.changeGlobalActType('', parseInt(this.state.currentUserData.id));
			if ( this.state.videosSwapped )
				{
					this.swapVideos();
					this.setState({videosSwapped:false});
				}
		}
  }

  muteUnmuteVideo = () => {
      if (this.state.muted === false) {
          this.setState({muted: true});
          this.state.player.muted = true;
      } else {
          this.setState({muted: false});
          this.state.player.muted = false;
      }
  }

  stopVideo = () => {
	  if ( this.state.roomSetupRunning ) { return false; }
	  console.log('stopVideo');
	  this.videoStopped = true;
      this.state.player.pause();
      this.setState({pause: true, videoStopedStatus: true});
      if (this.state.player.currentTime) this.state.player.currentTime = 0;
      this.state.progressBar.value = 0;
      this.setState({videoDuration: 0});
	  $('#movedEquipmentDem').addClass('d-none');
	  window['hostStartedEquipment'+this.state.currentUserData.id] = false;
	  $('#canvasWrap').addClass('d-none');
	  
	  window.pauseVirtualActivityStarted = false;
	  window.changeGlobalActType('', parseInt(this.state.currentUserData.id));
		
      let addObject = {"userId": this.state.currentUserData.id, "event": "video", "eventType": "stop", "details": JSON.stringify({"onDemandId": this.state.currentUserData.sessionData.ondemandId, "platform": this.platformDetails}), "timestamp": Util.getCurrentTimestamp()};
      this.sessionDataStore.addSessionData(addObject);

      if (this.state.isScriptAvailable) {
          clearInterval(this.syncTimer);
          this.resetScript();
          this.recordingStartTime = this.recordingStartTimeActual;
    		  
          if ( this.state.videosSwapped )
    			{
    				this.swapVideos();
    				this.setState({videosSwapped:false});
    				//window['clearCanvasOnDemand']();
    			}
      }

      $('#fitness-counter').text(0);
	  
  	  if ( this.state.roomTimerRunning )
  		{
  			this.stopRoomTimer();
  		}
	
	this.stopPlayer();
	this.showPlayerDemand(false);
  }

  resetScript = ()=> {
    $('#stop1-script').trigger('click');
  }

  updateProgressBar = () => {
      // Work out how much of the media has played via the duration and currentTime parameters
      var percentage = (100 / this.state.player.duration) * this.state.player.currentTime;
      // Update the progress bar's value
      if (isNaN(percentage)) {
          this.state.progressBar.value = 0;
      } else {
          this.state.progressBar.value = percentage;
      }

      this.applyFill(this.state.progressBar);

      let duration = Math.floor(this.state.player.currentTime);
      $('#time-elapsed').text(Util.convertSecondsToTime(duration));
      this.setState({videoDuration: percentage});

      if (percentage == 100) {
          window.isPaused = true;
          this.lastTime = null;
      }

      if (this.state.isScriptAvailable)
      {
          let currTimeMS = this.state.player.currentTime;
          let currTime = Math.round(this.state.player.currentTime);
          let timeDiff = currTime - currTimeMS;
		  var lastTimeVar = this.lastTime;
		  
          if ( timeDiff < 0.300000 )
			  {  
				  if ( this.lastTime != currTime && this.state.pause == false )
					  {
						  this.lastTime = currTime;
						  this.syncScript(currTime);
					  }
			  }
			  
			if ( this.rtmCodes )
				{
					
					if ( !this.startTimeRTM )
						{
							for ( var rtmTime in this.rtmCodes )
								{
									for ( var b = 0; b<this.rtmCodes[rtmTime].length; b++ )
										{
											if ( this.rtmCodes[rtmTime][b].indexOf("217") > -1 ) 
												{
													if ( !this.foundStartRtm )
														{
															this.foundStartRtm = true;
															var splitTime = rtmTime.split(":");
															var startMinutes = parseInt(splitTime[0]) * 60;
															this.startTimeRTM = startMinutes + parseInt(splitTime[1]);
														}
												}
										}
								}
						}
					
					if ( this.startTimeRTM && lastTimeVar != currTime && !this.videoStopped )
						{
							var currentTimeCalc = this.startTimeRTM - duration;
							var currentTimeMinutes = Math.floor(currentTimeCalc / 60);
							var currentTimeSeconds = currentTimeCalc % 60;
							var currentTimeString = currentTimeMinutes + ':' + currentTimeSeconds;
							var timeCurrentRep = ('0'+currentTimeMinutes).slice(-2)+':'+('0'+currentTimeSeconds).slice(-2);
							
							if ( this.rtmCodes[timeCurrentRep] != undefined )
								{
									for ( var i = 0; i < this.rtmCodes[timeCurrentRep].length; i++ )
										{
											console.log("rtmToSend---", this.rtmCodes[timeCurrentRep][i], this.state.currentUserData.sessionData.hostId);
											window.onChannelMessage({text: this.rtmCodes[timeCurrentRep][i], messageType: "TEXT"}, this.state.currentUserData.sessionData.hostEmail, true);
										}	
								}
						}
				}
	  }
  }

  slideSeek = (e) => {
      let progressBarValue = 0;
      if ( this.state.progressBar.value == 100 ) {
          progressBarValue = 100;
      }

      let duration = Math.floor(this.state.player.currentTime);

      if (this.state.isScriptAvailable) {
          this.calculateTimeDiff(duration);
      }
  }

  slideSeek1 = (e) => {
    console.log('mouse down');
  }

  applyFill = (slider) => {

      // First let's set the colors of our sliders
      const settings={
        fill: '#121126',
        background: '#434343'
      }

      // Let's turn our value into a percentage to figure out how far it is in between the min and max of our input
      const percentage = 100*(slider.value-slider.min)/(slider.max-slider.min);
      // now we'll create a linear gradient that separates at the above point
      // Our background color will change here
      const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background} ${percentage+0.1}%)`;
      slider.style.background = bg;
  }

  seek = (e) => {
	  if ( this.state.roomSetupRunning ) { return false; }
	  
      window.$('.main_loader').attr({'style':'display:flex'});
      window.$('.main_loader').removeClass('video_behind_loader');

      this.applyFill(e.target);
      let progressBarValue = 0;

      if (this.state.isScriptAvailable) {
		console.log('isScriptAvailable');
        this.state.player.pause();
        this.setState({pause: true});
        clearInterval(this.syncTimer);
      }

      var curr_item = e.currentTarget;
      var move_left = e.pageX - $(curr_item).offset().left;

      var position = (move_left / parseInt($(curr_item).width()));
      this.state.player.currentTime = position * this.state.player.duration;

      let duration = Math.floor(this.state.player.currentTime);
      $('#time-elapsed').text(Util.convertSecondsToTime(duration));
      this.setState({videoDuration: e.target.value});
	  this.stopPlayer();

      if (this.state.isScriptAvailable) {
          this.calculateTimeDiff(duration);
      } else {
          this.setState({pause: false});
          this.state.player.play();
      }
  }

  calculateTimeDiff = (duration) => {
      this.deadline = new Date(this.recordingStartTimeActual).getTime() + (duration * 1000);
      console.log('progress deadline new - ', this.deadline, duration);

      let prevData = '';
      this.syncArr.forEach((scriptData)=>{
          if(scriptData.time <= this.deadline && scriptData.rtm != 202) {
              prevData = scriptData;
          }
      });

      this.syncFitnessScript(prevData);
  }

  syncFitnessScript = (resultant) => {
      console.log('seek script - ', resultant);
      
      this.resetScript();
      let that = this;

      setTimeout(function(){
          $('.swiper-slide').each(function (index, value) {

              if(parseInt($(this).attr('data-index')) == resultant.index) {
				  $('.swiper-slide').removeClass('swiper-slide-next');
                  $(this).addClass('swiper-slide-next');
                  $(this).removeClass("remove-slider-bg");

                  if (!isNaN(resultant.timeRemaining)) {

                      let timeRemaining = 0;

                      if ($(this).find('.interval').length > 0) {

                          let totalTime = parseInt($(this).find('.countdown-number').attr('data-number')) * parseInt($(this).find('.interval').attr('intervaltime'));

                          if (resultant.rtm == 404) {
                              let timeDiff = resultant.timeRemaining - ((that.deadline - resultant.time) / 1000);
                              timeRemaining = parseInt(timeDiff);
                              $(this).find('#reps-counter').text(timeRemaining);

                              let timeElapsed = totalTime - timeRemaining;
                              let repsRemaining = parseInt($(this).find('.countdown-number').attr('data-number')) - Math.floor(timeElapsed / parseInt($(this).find('.interval').attr('intervaltime')));
                              $(this).find('.countdown-number').text(repsRemaining);
                          } else {
                              timeRemaining = resultant.timeRemaining;
                              $(this).find('#reps-counter').text(timeRemaining);

                              let timeElapsed = totalTime - timeRemaining;
                              let repsRemaining = parseInt($(this).find('.countdown-number').attr('data-number')) - Math.floor(timeElapsed / parseInt($(this).find('.interval').attr('intervaltime')));
                              $(this).find('.countdown-number').text(repsRemaining);
                          }
                      } else {
                          if (resultant.rtm == 404) {
                              let timeDiff = resultant.timeRemaining - ((that.deadline - resultant.time) / 1000);
                              timeRemaining = timeDiff > 0 ? parseInt(timeDiff) : 0;
                          } else {
                              timeRemaining = resultant.timeRemaining;
                          }

                          $(this).find('.countdown-number').text(timeRemaining);
                      }

                      $(this).find('svg circle').css({"animation":"countdown "+parseInt(timeRemaining)+"s linear infinite forwards", "animation-direction": "reverse"});
                  } else {

                      let timeDiff = (that.deadline - resultant.time) / 1000;
                      let timeRemaining = 0;

                      if ($(this).find('.interval').length > 0) {
                          let totalTime = parseInt($(this).find('.countdown-number').attr('data-number')) * parseInt($(this).find('.interval').attr('intervaltime'));
                          timeRemaining = totalTime - timeDiff;
                          $(this).find('#reps-counter').text(timeRemaining);

                          let timeElapsed = totalTime - timeRemaining;
                          let repsRemaining = parseInt($(this).find('.countdown-number').attr('data-number')) - Math.floor(timeElapsed / parseInt($(this).find('.interval').attr('intervaltime')));
                          $(this).find('.countdown-number').text(repsRemaining);
                      } else {

                          timeRemaining = parseInt($(this).find('.countdown-number').attr('data-number')) - parseInt(timeDiff);
                          timeRemaining = timeRemaining > 0 ? timeRemaining : 0;
                          console.log('new time reminaing - ', timeRemaining);
                          $(this).find('.countdown-number').text(timeRemaining);
                      }

                      if (timeRemaining < 0) {
                          timeRemaining = 0;
                      }

                      $(this).find('svg circle').css({"animation":"countdown "+parseInt(timeRemaining)+"s linear infinite forwards", "animation-direction": "reverse"});
                      //$(this).find('svg circle').css({"animation-play-state":"running"});
                  }

                  switch(resultant.rtm) {
                      case 211: 
                          window.countDown();
                          break;
                      case 212: 
                          this.resetScript();
                          break;
                      case 213: 
                          window.isPaused = true;
                          $(this).find('svg circle').css({"animation-play-state":"paused"});
                          window.countDown();
                          break;
                      case 214: 
                          window.isPaused = false;
						  console.log('paused 2');
                          window.countDown();
                          break;
                      case 404: 
                          window.isPaused = false;
						  console.log('paused 3');
                          $(this).find('svg circle').css({"animation-play-state":"running"});
                          window.countDown();
                          break;
                  }

                  return;
              } else if(parseInt($(this).attr('data-index')) < resultant.index) {
                  $(this).addClass('swiper-slide-active');
                  $(this).find('.countdown-number').text('0');

                  window.mySwiper.slideNext();
              }
          });

          that.setState({pause: false});
          that.state.player.play();
      }, 1000);
  }

  changeDuration = (e) => {
      if (this.state.can_change_duration === true) {
          var curr_item = e.currentTarget;
          var move_left = e.pageX - $(curr_item).offset().left;
          var percent = Math.floor((move_left / parseInt($(curr_item).width())) * 100);
          e.target.value = percent;

          var position = (move_left / parseInt($(curr_item).width()));
          this.state.player.currentTime = Math.floor(position * Math.floor(this.state.player.duration));

          let duration = Math.floor(this.state.player.currentTime);
          $('#time-elapsed').text(Util.convertSecondsToTime(duration));
          this.setState({videoDuration: percent});
      }
  }
  
	playPlayer=(id)=>{
		this.playerFunctions.stopPlayer();
		this.playerFunctions.playPlayer(id);
		this.setState({currentStationId: id, showPlayer: true});
		window['currentStationId'] = id;
	}

	stopPlayer=()=>{
		this.playerFunctions.stopPlayer();
		this.setState({currentStationId: "", showPlayer: false});
		window['currentStationId'] = "";
	}

  componentDidMount(){
	    this.loadPreLoadedVideo();
	    let mainthis = this;
		var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
		var sessionStations = sessionData.sessionStations;
		var sessionTimes = [];
		for ( let i = 0; i < sessionStations.length; i++ ) 
			{ 
				sessionTimes.push(sessionStations[i].time); 
			}
		
		if ( window['userWhiteboard'] ){ this.setState({whiteboardLoaded: true}); }
		
		/* var vid = document.getElementById("video-element");
		vid.ontimeupdate = function() {
			var currentSeconds = vid.currentTime;
			var currentMinute = Math.floor(currentSeconds / 60);
			if ( sessionTimes.indexOf(currentMinute) > -1 )
				{
					var index = sessionTimes.indexOf(currentMinute);
					var stationMain = sessionStations[index];
					if ( parseInt(stationMain.stationId) > 0 )
						{
							if ( mainthis.state.currentStationId == stationMain.stationId ) { return false; }
							
							mainthis.playPlayer(stationMain.stationId);
						}
					else
						{
							if ( mainthis.state.currentStationId == "" ) { return false; }
							
							mainthis.stopPlayer();
						}
				}
		}; */
		
		window.captureElectronError = (eventType, errMsg) =>
			{
				let addObject = {"sessionId": this.state.currentUserData.sessionData.id, "event": "error", "eventType": eventType, "userId": this.state.currentUserData.id, "details": JSON.stringify({"msg": errMsg}), "timestamp": Util.getCurrentTimestamp()};
				this.sessionDataStore.addSessionData(addObject);
			}

      this.setLocalPreview();
      this.initListeners();
      this.prepareData();
      this.rtmJoin();
	  this.saveBoxJump('hostInfo', 0);
	  this.getWhiteboardValues();
	
  	  axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/checkOnDemandSession", {id: this.state.currentUserData.sessionData.ondemandId}).then(res => {
  			if ( res.data.responseData.length === 0 )
  				{
  					$('#on_demand_failed').attr({'style':'display:block'});
  					setTimeout(() => { window.close(); }, 3000);
  				}
  		}).catch(err =>{ });

  		$('body').addClass('zoomHostFull');
  		$('body').addClass('zoomHostFullShow');
	
    	$(document).off('click', '.zoomFullScreen');
	
        $(document).on('click', '.zoomFullScreen', function(){
    
            if ($('body').hasClass('zoomHostFull') && $('body').hasClass('zoomHostFullShow') )
            {
                $('body').removeClass('zoomHostFullShow');
                $('.zoomFullScreen').removeClass('less_left_stream');
                $('.zoomFullScreen').removeClass('behindHRT_stream');
            }
            else if ($('body').hasClass('zoomHostFull') )
            {
                $('body').removeClass('zoomHostFull');
                $('.fullVideoBox').addClass('hostVideo');
                $('#agora_host').removeAttr("style");
                $('.zoomFullScreen').addClass('behindHRT_stream');
                $('.zoomFullScreen').removeClass('less_left_stream');
            }
            else
            {
                $('body').addClass('zoomHostFull zoomHostFullShow');
                $('.fullVideoBox').removeClass('hostVideo');
                $('#agora_host').removeAttr("style");
                $('.zoomFullScreen').addClass('less_left_stream');
                $('.zoomFullScreen').removeClass('behindHRT_stream');
            }
        });
		
		$(document).off('click', 'input[name="video-type"]');
		$(document).on('click', 'input[name="video-type"]', function(){
			var deviceId = $(this).attr('value');
			mainthis.localStream.getVideoTracks().forEach(function(track) {
			  track.stop();
			});
			mainthis.cameraId = deviceId;
			mainthis.setLocalPreview();
			mainthis.openCamSettings();
		});

      	$(window).resize(function() {
      		if ( $('#agora_host').offset() && $('#agora_host').offset().left < 120 )
      				{
      					$('.zoomFullScreen').addClass('behindHRT');
      				}
      			else
      				{
      					$('.zoomFullScreen').removeClass('behindHRT');
      				}
      	});

        if ( window['electron'] ) {
            let appVersion = '';
            if ( window.navigator.appVersion.indexOf('Windows') == -1 )
            {
                appVersion = this.state.currentUserData.default.appVersionApple;
            }
            else
            {
                appVersion = this.state.currentUserData.default.appVersionWindows;
            }

            this.platformDetails = {OS:osname, Browser:'Native', Version:appVersion}
        } else {
            this.platformDetails = {OS:osname, Browser:browserName, Version:fbrowserversion, DeviceType:deviceType}
        }
		
		mainthis.updateHeartRate(this.state.currentUserData.id, this.state.currentUserData.email, function(hrreturn) {
            console.log('mobile heart rate --- ', hrreturn);
            mainthis.displayHealthStats(hrreturn);
        }); 
		
		this.getVideoResolution();
		
		var activity = this.state.currentUserData.sessionData.scriptDetail;
		for ( var i = 0; i < activity.length; i++ )
			{
				for ( var a = 0; a < activity[i].attribute.length; a++ )
					{
						if ( activity[i].attribute[a].attrLabel === 'Activity Type' )
							{
								if ( activity[i].attribute[a].attrValue === 'Virtual Assistant' || activity[i].attribute[a].attrValue === 'Virtual Equipment' )
									{
										window['hasConeScript'] = true;
									}
							}
					}
			}		
		
		if ( this.state.currentUserData.sessionData.rtmCodes )
			{	
				var rtmCodesArray = this.state.currentUserData.sessionData.rtmCodes;
				var rtmCodesObject = {};
				
				for ( var i = 0; i < rtmCodesArray.length; i++ )
					{
						var currentRTMCode = JSON.parse(rtmCodesArray[i]['rtmCode']);
						for ( var index in currentRTMCode )
							{
								if ( !rtmCodesObject[index] )
									{
										rtmCodesObject[index] = currentRTMCode[index];
									}
							}
					}
				
				this.rtmCodes = rtmCodesObject;
				console.log(this.rtmCodes, 'rtmCodes');
			}
		
		if ( window['userWhiteboard'] && window['userWhiteboard'][this.state.currentUserData.id] ){ window['userWhiteboard'][this.state.currentUserData.id].loadElements(); }
  }
  
  prepareData = () => {

      if (this.state.currentUserData.sessionData.scriptDetail !== undefined && this.state.currentUserData.sessionData.scriptDetail.length > 0) {
        let sessionData = JSON.parse(JSON.stringify(this.state.currentUserData.sessionData.sessionStoreData));
        let lastTime = null;
        let bpmLastTime = null;

        sessionData.forEach((data)=>{
            let details = JSON.parse(data.details);

            if (data.rtm == 205 && details.action == 'recordingButtonStart' && this.recordingStartTime === null) {
                let time = new Date(data.time).getTime();
                this.recordingStartTime = new Date(time);
                this.recordingStartTimeActual = new Date(time);
            } else if (data.rtm == 205 && details.action == 'recordingUpload') {
                if (this.recordingEndTime === null) {
                    this.recordingEndTime = new Date(data.time).getTime();
                }
            } else if (data.rtm == 202 && this.recordingStartTime !== null) {
                let emojiTime = new Date(data.time).getTime();

                if (lastTime != emojiTime) {
                    var scriptObj = {};
                    scriptObj.rtm = parseInt(data.rtm);
                    scriptObj.time = emojiTime;
                    this.syncArr.push(scriptObj);

                    lastTime = emojiTime;
                }

                var emojiObj = {};
                emojiObj.value = details.value;
                emojiObj.name = details.name;
                emojiObj.time = emojiTime;

                this.emojiArr.push(emojiObj);
            } else if (data.rtm == 206 && this.recordingStartTime !== null) {
                let bpmTime = new Date(data.time).getTime();

                if (bpmLastTime != bpmTime) {
                    var scriptObj = {};
                    scriptObj.rtm = parseInt(data.rtm);
                    scriptObj.time = bpmTime;
                    this.syncArr.push(scriptObj);

                    bpmLastTime = bpmTime;
                }

                var bpmObj = {};
                bpmObj.value = details.value;
                bpmObj.name = details.name;
                bpmObj.time = bpmTime;

                this.bpmArr.push(bpmObj);
            } else if (data.rtm != 205 && this.recordingStartTime !== null) {
                var scriptObj = {};
                scriptObj.rtm = parseInt(data.rtm);
                scriptObj.time = new Date(data.time).getTime();
                scriptObj.index = details.scriptIndex;
                scriptObj.timeRemaining = parseInt(details.timeRemaining);

                this.syncArr.push(scriptObj);
            }
        });

        console.log('emoji arr - ', this.emojiArr);
      }
  }

  syncScript = (currTime) => {

      let scripts   = this.syncArr;
      let userData  = this.state.currentUserData;
      let that = this;

      that.deadline = new Date(that.recordingStartTimeActual).getTime() + ( currTime * 1000 );
      //console.log('deadline - ', that.deadline, ' - ', currTime);

      if (that.deadline == that.recordingEndTime) {
          window.isPaused = true;
          clearInterval(that.syncTimer);
      } else {

          scripts.forEach((scriptData)=>{
              if (that.deadline == scriptData.time) {
                  console.log('aaaa===111 - ', that.deadline, '========', scriptData.time, scriptData.rtm, scriptData.index);

                  switch(scriptData.rtm) {
                    case 211: 
                       if ( window['startSlider'] )
							{
								window.startSlider();
							}					
                        window.isPaused = false;
						console.log('paused 4');
                        break;
                    case 212: 
                        that.resetScript();
                        break;
                    case 213: 
						console.log('window.isPaused');
                        //window.isPaused = true;
						if ( window['userWhiteboard'] && window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].globalActType != "" )
						  {
							  window['userWhiteboard'][this.state.currentUserData.id].doActivityEvents('activityStarted');
						  }
                        break;
                    case 214: 
                        window.isPaused = false;
						console.log("SCRIPT DATA INDEX---", scriptData);
                        if ( window['syncScriptOnDemand'] )
							{
								window.syncScriptOnDemand(scriptData.index);
							}					
                        break;
                    case 404: 
                        window.isPaused = false;
						console.log('paused 6');
                        break;
                    case 202: 
                        that.displayEmojis(scriptData.time);
                        break;
                    case 206: 
                        that.displayBPM(scriptData.time);
                        break;
                  }
              }
          });
      }
  }

  displayEmojis = (timestamp) => {
      let that = this;
      this.emojiArr.forEach((emojiData)=>{
          if (emojiData.time == timestamp) {
              that.animateEmojis(emojiData);
          } else if (emojiData.time > timestamp) {
              return;
          }
      });
  }

  displayBPM = (timestamp) => {
      let that = this;
      this.bpmArr.forEach((bpmData)=>{
          if (bpmData.time == timestamp) {
              that.animateEmojis(bpmData, 'bpm');
          } else if (bpmData.time > timestamp) {
              return;
          }
      });
  }

  animateEmojis = (data, category = '') => {

    if (category == 'bpm') {
        $('.particlecontainer').append('<span class="particle"><img src="./images/heart.png" /><span class="text-white participant-bpm">'+data.value+'</span><span class="bottomtext">'+data.name+'</span></span>');
    } else {
        $('.particlecontainer').append('<span class="particle"><img src="./images/'+Const.APPEREANCE[data.value]+'" /><span class="bottomtext">'+data.name+'</span></span>');
    }

    $('.particle').toArray().forEach(function(particle) {

        $(particle).animate({
              right: Util.generateRandomNumber(0, $('.particlecontainer').width())
        }, Util.generateRandomNumber(10, 30), function() {       

            $(particle).animate({
                top: -50 + "%"
            }, Util.generateRandomNumber(8000, 10000), function() {
                $(particle).remove();
            });
        });
    });
  }
  
  initListeners = () => {
      document.getElementById('video-element').addEventListener('timeupdate', this.updateProgressBar, false);
      document.getElementById('video-element').addEventListener('ended', this.endVideo, false);
      document.getElementById('video-element').addEventListener('canplay', () => {
        $('.zoomFullScreen, .zoomFullScreenButton').removeClass('d-none');
        $('.zoomFullScreenButton').html($('body').hasClass('zoomHostFullShow') ? '<a class="text-white">HIDE ALL</a>' : '<a class="text-white">SHOW ALL</a>');
      });
      document.getElementById('progress-bar').addEventListener("click", this.seek);
      document.getElementById('progress-bar').addEventListener("mousedown", this.slideSeek1);
	  console.log('initListeners');
      document.getElementById('video-element').addEventListener('loadedmetadata', () => {
          let duration = Math.floor(document.getElementById('video-element').duration);
          $('#video-duration').text(Util.convertSecondsToTime(duration));
          this.setState({videoDurationCalculated: true});
          $('.main_loader').hide();
          $('.main_loader').addClass('video_behind_loader');

          if ( !safari ) 
          {
              setTimeout(() => {
                  this.playPause('forcePlay');
				  console.log('playPause 441');
              }, 1000);
          }
      });
      document.getElementById('video-element').addEventListener('waiting', () => {
          console.log('video data buffering...');
          window.isPaused = true;
          this.buffering = true;
      });
      document.getElementById('video-element').addEventListener('playing', () => {
          console.log('video data playing...');
          $('.main_loader').hide();
          $('.main_loader').addClass('video_behind_loader');

          if (this.buffering) {
              this.buffering = false;
              window.isPaused = false;
			  console.log('paused 7');
          }
      });
  }

  setLocalPreview = () => {
		var device;
		let that = this;
		let defaultSetting = '';
		var cameraSet = false;
		var index = 0;
		if ( this.cameraId == null ) 
			{
				let vdoMediaList = '';
				$('#camera-list').html('');	
				
				navigator.mediaDevices.enumerateDevices().then(function(devices) {
				  devices.forEach(function(device) {
					if ( device.kind === 'videoinput' )
						{
							if ( !device.label || device.label == '' || device.label == null || device.label == undefined )
								{
									var cameraNum = index + 1;
									device.label = 'Camera '+cameraNum;
								}
							
							defaultSetting = '';
							
							if ( !cameraSet && ( !window['cameraValue'] || (window['cameraValue'] && window['cameraValue'] == device.deviceId)) )
								{
									that.cameraId = device.deviceId;
									defaultSetting = 'checked';
									cameraSet = true;
								}
								
							vdoMediaList = '<div class="check-camera-audience"><input type="radio" class="form-radio" name="video-type" id="lbl-'+index+'" data-keyid="'+index+'" value="'+device.deviceId+'" '+ defaultSetting +'><label for="lbl-'+index+'"> '+ device.label +'</label></div></div>';

							$('#camera-list').append(vdoMediaList);
							index++;
						}
				  });
				})
				.catch(function(err) {
				  console.log(err.name + ": " + err.message);
				});
			}
			
		var constraints = {
				audio: false,
				video: {
					width: 640 ,
					height: 360 ,
					deviceId: this.cameraId
			  }
		  };
		  
		if ( this.state.resolutionChosen !== '' )
			{
				if ( this.state.resolutionChosen === 'sd' )
					{
						constraints.video.width = { ideal: 640 };
						constraints.video.height = { ideal: 360 };
					}
					
				if ( this.state.resolutionChosen === 'hd' )
					{
						constraints.video.width = { ideal: 1280 };
						constraints.video.height = { ideal: 720 };
					}
					
				if ( this.state.resolutionChosen === 'hdp' )
					{
						constraints.video.width = { ideal: 1920 };
						constraints.video.height = { ideal: 1080 };
					}
			}	
		
		if( this.cameraId || chrome)
			{
				navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
					that.onUserMediaSuccess(stream);
					that.setState({streamError: false});
					var preview = document.getElementById("local_preview");
					preview.srcObject = stream;
					if (that.state.streamStatus && !ff )
						{
							preview.play();
							that.state.streamStatus = false;
						}
				}).catch(function (error) { console.log("Something went wrong!", error); });
			}			
		
  }

  onUserMediaSuccess = (stream) => {
    console.log('NEW STREAM---', stream);
	this.localStream = stream;
	this.state.streamStatus = true;
  }

  rtmJoin = () => {
      if(this.newclient == undefined){

        this.newclient = this.AgoraRTM.createInstance(this.state.currentUserData.rtmAppId, {enableLogUpload: false, logFilter: this.AgoraRTM.LOG_FILTER_OFF});

        this.newclient.on('MessageFromPeer', (message, peerId) => { 
            console.log('MessageFromPeer - ', message.text, peerId);
            this.signalHandler(peerId, message.text);
        });

        this.newclient.on('ConnectionStateChanged', (newState, reason) => {
            
            console.log('connectionstate changed to: ' + newState + ' reason: ' + reason);

            if ( reason == 'REMOTE_LOGIN' ) {
                this.newclient.logout();
				this.onLogoutClick();
            } else {
                if ((newState == 'ABORTED' || newState == 'DISCONNECTED') && (reason == 'LOGIN_TIMEOUT' || reason == 'INTERRUPTED' || reason == 'REMOTE_LOGIN' || reason == 'LOGIN_FAILURE' || reason == 'BANNED_BY_SERVER')) {
                    this.newclient.logout();
                    setTimeout(this.doClientLogin, 500);
                }
            }
        });

        this.doClientLogin();      
      }
  }

  doClientLogin = () => {
      this.newclient.login({ token: null, uid: this.state.currentUserData.email }).then(() => {
          console.log('login success');
      }).catch(err => {
          console.log('###RTM login error - ', err);
      });
  }

  signalHandler = (uid, signalData) => {
      console.log('Function - signalHandler - ' + signalData + ' - email: ' + uid);

      let resultant = signalData.split('~@$');

      switch(resultant[0]) {
        case '1': 
                  this.playPause();
				  console.log('playPause 22');
                  break;
        case '2': 
                  this.stopVideo();
				  console.log('stopVideo');
                  break;
        case '3': 
                  this.muteUnmuteVideo();
                  break;
        case '206': 
                  let hrData = JSON.parse(resultant[1]);
                  console.log('###hr ---- ', hrData, hrData['heartRate']);
                  this.displayHealthStats(hrData);
                  break;
      }
  }

  displayHealthStats = (signalData) => {
      $('.bpm-bar').removeClass('d-none');
      if( signalData['heartRate'] ) { $('#hr').text(parseInt(signalData['heartRate'])); }
      if( signalData['calories'] ) { $('#calories').text(parseInt(signalData['calories'])); }
      if( signalData['vo2'] ) { $('#vo2').text(parseInt(signalData['vo2'])); }
      $('.skills').addClass('bpm');
      $('#bpm').removeClass('opacity-zero');
  }

  handleChange = (event) => {
	if ( this.state.roomSetupRunning ) { return false; }
	  
    this.setState({value: event.target.value});
  }

  zoomVideo = () => {
      if ( $('#footerId').hasClass('d-none') ) 
      {
          $('.expand-ondemand').find('img').attr('src', 'images/full-screen.png');
          $('#footerId').removeClass('d-none');
          $('.attend-mid-section').addClass('ondemandmiddlescreen');
          $('.heartrateg').addClass('max-width-300 d-flex').removeClass('d-none');
          $('#agora_host').find('video').removeAttr('style');
          $('.container').addClass('justify-content-between');
          $('.expand-ondemand').removeAttr('style');
      } 
      else 
      {
          $('.expand-ondemand').find('img').attr('src', 'images/exit-screen.png');
          $('#footerId').addClass('d-none');
          $('.attend-mid-section').removeClass('ondemandmiddlescreen');
          $('.heartrateg').removeClass('max-width-300 d-flex').addClass('d-none');
          $('#agora_host').find('video').css({"cssText": "max-width: calc((100vh - 152px)*16/9) !important; max-height: calc(100vh - 152px) !important"});
          $('.container').removeClass('justify-content-between');
          $('.expand-ondemand').css('top', '10%');
      }
  }

  hideVideoPopup = () => {
      var video = document.getElementById('video_script');
      video.setAttribute("src", '');
      $('#ac_list_pop').removeClass('blur_activity');
  }
  
  getWhiteboardValues = () => {
	  axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/whiteboardValues", {}).then(res => {
			console.log(res);
			if ( res.data.responseData )
				{
					let userData = this.state.currentUserData;
					userData.whiteboardValues = res.data.responseData;
					this.setState({currentUserData:userData});
					window['currentUserData'] = this.state.currentUserData;
					localStorage.setItem('userData', JSON.stringify(userData));
				}
		}).catch(err =>{ });
  }

  startDrawing = (scriptName, act_type) => {
	  let scrName = scriptName;
	  window['usingPose'] = true;
	  window['globalScriptDemand'] = scriptName;
	  $('#currentWorkout').text(scriptName);
	  if ( act_type == 'Pause' ) { $('#currentWorkout').text('Demo '+ scriptName); }
	  
	  if ( !window['electron'] || android || ipad13 )
			{
				window['deviceNotSupported'] = true;
				$('#virtualMsg').text('Device Not Supported').removeClass('d-none');
				return false;
			}
			
	  if ( !window['hasConeScript'] )
		{
			return false;
		}
	  
	  if ( !this.state.videosSwapped && act_type != 'Pause Virtual' )
		{
			this.swapVideos();
			this.setState({videosSwapped:true});
		}
		
	  if ( !this.state.whiteboardLoaded )
		{
			/* $('#sessionCanvas')[0].width = $('#local_preview').width();
			$('#sessionCanvas')[0].height = $('#local_preview').height();
			$('#imageCanvas')[0].width = $('#local_preview').width();
			$('#imageCanvas')[0].height = $('#local_preview').height(); */
			//loadWhiteboard();
			this.userWhiteboard = new whiteboard({'user_id': this.state.currentUserData.id});
			window['userWhiteboard'][this.state.currentUserData.id] = this.userWhiteboard;
			window['userWhiteboard'][this.state.currentUserData.id].currentActivityName = scriptName;
			
			this.setState({whiteboardLoaded:true});
		}
	  $('#canvasWrap').removeClass('d-none');
	 // if ( ( scrName !== 'Lateral Cone Touch' || scrName !== 'Boxing Bag 1' ) && !window['workoutAreaSetupDone'+this.state.currentUserData.id] ) { scrName = 'Boxing Bag 1'; }
	 // window['onDemandEquipment'](scrName);
	 // window['scriptNameDemand'] = scrName;
	  console.log('scrName', scrName);
	  window['userWhiteboard'][this.state.currentUserData.id].activityStarted(scrName);
	  window.isPaused = false;
	  $('.start_room_button_holder').addClass('d-none');
		var checkRoom = this.checkRoomSetup();
		console.log('checkRoom', checkRoom);
	  
		if ( !this.state.roomTimerStarted && !checkRoom )
			{
				let mainthis = this;
				setTimeout(function() {
					if ( mainthis.state.pause === false ) 
						{
							mainthis.playPause();
							console.log('playPause3');
						}
				}, 500);
				
				$('#toolTip .tooltipNumber').addClass('d-none');
				$('#toolTip').removeClass('d-none');
				
				$('.tooltipText').html('Room Setup');
				$('.part_inner').html('Time to get the room setup!');
				$('.walk_tool_text').html('Start Room Setup');
				$('.hostToolTip, #walkToolImage, .upNext').removeClass('d-none');
				$('#walkToolImage').addClass('d-none');
				$('#workoutTimer').text('00:00');

				setTimeout(function(){ $('#walkToolImage').removeClass('d-none'); }, 3000);
				
				//setTimeout(function() { mainthis.setState({roomSetupRunning:true}); }, 600);
			}
  }
  
  roomSetup = () => {
	  console.log('roomSetup111');
		window.soundPlay.stopAudio();
		window.soundPlay.playAudio('BeforeRoomSetup');
		$('.tooltipText').html('');
		$('.part_inner').html('');
		$('.walk_tool_text').html('');
		$('.hostToolTip, #walkToolImage, .upNext').addClass('d-none');
		$('#walkToolImage').addClass('d-none');
		this.showPopupOndemand();
  }
  
  startRoomSetup = () => {
	  console.log('roomSetup222');
	  if (this.state.pause === false) { this.playPause(); }
	  this.setState({roomTimerRunning:true});
	  this.setState({roomTimerStarted:true});
	  window.startRoomSetup();
	  //window['userWhiteboard'][this.state.currentUserData.id].roomSetup.startRoomSetup();
  }
  
  closeDrawing = (scriptName) => {
	  this.hideShowFooter(false);
	  if ( this.state.videosSwapped )
		{
			window['usingPose'] = false;
			this.swapVideos();
			this.setState({videosSwapped:false});
			$('#canvasWrap').addClass('d-none');
			//window['clearCanvasOnDemand']();
		}
  }
  
  checkRoomSetup = () => {
	var roomSetDone = true;
			
	if ( !window['userWhiteboard'][this.state.currentUserData.id] || (window['userWhiteboard'][this.state.currentUserData.id] && !window['userWhiteboard'][this.state.currentUserData.id].roomSetup.workoutAreaSetupDone) )
		{
			roomSetDone = false;
			$('.start_room_button_holder ').addClass('d-none');
		}
		
	return roomSetDone;
}

  swapVideos = () => {
	  var elm1 = $('#local_preview');
      var elm2 = $('#video-element');
	  
	  var parent1, next1,
          parent2, next2;
	  parent1 = elm1[0].parentNode;
	  next1   = elm1[0].nextSibling;
	  parent2 = elm2[0].parentNode;
	  next2   = elm2[0].nextSibling;
	  parent1.insertBefore(elm2[0], next1);
      parent2.insertBefore(elm1[0], next2);
	  
	  elm2[0].style.marginLeft = 0;
	  
	  $('.particlecontainer').css('pointer-events', 'none');
	  
	  console.log($('#video-element').attr('style'));
	  
	  if ( !this.state.videosSwapped )
		{
			$('.video-holder').css('transition', '1s');
			$('.video-holder').addClass('hostCamLeft');
			$('.hostCamBack').removeClass('d-none');
			$('.hostCamBack').removeClass('backLeft');
			$('#launcher').css({'transition': '1s', 'right': '-95px'});
			$('#activityCounter').removeClass('d-none');
			$('#activityName').removeClass('d-none');
			$('#repcounter').removeClass('d-none');
			this.hideShowFooter(true);
		}
	  else
		{
			$('.video-holder').removeClass('hostCamLeft');
			$('.hostCamBack').addClass('d-none');
			$('#launcher').css('right', '0px');
			$('#activityCounter').addClass('d-none');
			$('#activityName').addClass('d-none');
			$('#repcounter').addClass('d-none');
			$('.participant_stats_hold').addClass('d-none');
			this.hideShowFooter(false);
		}
  }
  
  loadPreLoadedVideo = () => {
	  var elm1 = $('#video-element');
      var elm2 = $('#canvasWrap');
	  
	  var parent1, next1,
          parent2, next2;
	  parent1 = elm1[0].parentNode;
	  next1   = elm1[0].nextSibling;
	  parent2 = elm2[0].parentNode;
	  next2   = elm2[0].nextSibling;
	  //parent1.insertBefore(elm2[0], next1);
      parent2.insertBefore(elm1[0], next2);
	  
	  this.setState({isScriptAvailable: this.state.currentUserData.sessionData.scriptDetail !== undefined && this.state.currentUserData.sessionData.scriptDetail.length > 0}, () => { if(!this.state.isScriptAvailable) { $('#footerId').addClass('script_background_none'); } });
      this.setState({sessionScript: this.state.currentUserData.sessionData.id, player: document.getElementById('video-element'), progressBar: document.getElementById('progress-bar')});
  
	  let duration = Math.floor(document.getElementById('video-element').duration);
	  $('#video-duration').text(Util.convertSecondsToTime(duration));
	  this.setState({videoDurationCalculated: true});
	  $('.main_loader').hide();
	  $('.main_loader').addClass('video_behind_loader');

	  if ( !safari ) 
	  {
		  setTimeout(() => {
			  this.playPause('forcePlay');
			  console.log('playPause 441');
		  }, 1000);
	  }
  }
  
  hostCamBack = () => {
	  if ( !$('.hostCamBack').hasClass('backLeft') )
		{
			$('.video-holder').removeClass('hostCamLeft');
			$('.hostCamBack').addClass('backLeft');
		}
	  else
		{
			$('.video-holder').addClass('hostCamLeft');
			$('.hostCamBack').removeClass('backLeft');
		}
  }

  stopRoomTimer = () => {
	  clearInterval(this.zeroTimer);
	  clearTimeout(this.zeroTimeout);
	  //window.soundPlay.stopAudio();
	  this.setState({roomTimerRunning:false});
	  this.setState({roomTimerStarted:false});
	  $('#toolTip').addClass('d-none');
  }

  showHideLocalPreview = () => {
    if ( this.state.hideLocalStream === true ) 
		{
			this.setState({'hideLocalStream': false});
			if ( !this.state.videosSwapped )
				{
					this.setLocalPreview();	
				}			
		}
    else
		{
			$('.click-switch-camera').find('i').removeClass('arrow-down').addClass('arrow-up');
			$('#change-camera').addClass('d-none');
			this.setState({'hideLocalStream': true});
			if ( !this.state.videosSwapped )
				{
					this.setLocalPreview();
					this.localStream.getVideoTracks()[0].stop();
				}
		}
  }
  
 getVideoResolution = () =>{
	  var videoInfo;
	  var putVideoInfo;
	  axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getCustomResolution", { 'userId': this.state.currentUserData.id  }).then(res => {
			videoInfo = res.data.responseData.videoResolutionParticipant;
			console.log(videoInfo, 'videoInfo');
			putVideoInfo = videoInfo == 1 ? 'hd' : videoInfo == 0 ? 'sd' : 'hdp';
			this.changeResolutionTo(putVideoInfo);
		}).catch(err =>{ console.log('err--', err); }); 
  }
  
  changeResolutionTo = (newres) => {
		var mainThis = this;
		if ( mainThis.localStream !== null )
			{
				mainThis.localStream.getVideoTracks().forEach(function(track) { track.stop(); });
			}
		
		window['currentResolution'] = newres;
		$('.check-camera-resolutions input').prop("checked", false);
		if ( newres == 'sd' )
			{
				$('#resolutsd').prop("checked", true);
				setTimeout(function () { mainThis.applyCameraRestrict(); }, 2000);
			}
		else if ( newres == 'hd' )
			{
				$('#resoluthd').prop("checked", true);
				setTimeout(function () { mainThis.applyCameraRestrict(); }, 2000);
			}
		else if ( newres == 'hdp' )
			{
				$('#resoluthdp').prop("checked", true);
				setTimeout(function () { mainThis.applyCameraRestrict(); }, 2000);
			}
		
		this.setState({resolutionChosen: newres}, () => {this.setLocalPreview()});		
		
		let sendVideoInfo = newres;
		let sendVideo = sendVideoInfo == 'hd' ? 1 : sendVideoInfo == 'sd' ? 0 : 2; 
		
		let varId = this.state.currentUserData.id;
		if ( window['resetWhiteDrawSkip'+varId] ) 
			{ 
				window['resetWhiteDrawSkip'+varId](varId); 
			}
			
		$('.click-switch-camera').find('i').removeClass('arrow-down').addClass('arrow-up');
		$('#change-camera').addClass('d-none');
  }
  
  applyCameraRestrict = () => {
	if ( window.whiteCam && window.whiteCam.addOn && window.whiteCam.addOn.CameraChange && window.currentUserData && window.currentUserData.default && parseInt(window.currentUserData.default.useCameraZoomLock) )
		{
			var currentCamera = $('input[name="video-type"]:checked').val();
			if( currentCamera )
				{
					//window.whiteCam.addOn.CameraChange(currentCamera);
				}
		}
  }
  
 equipmentIsReady = () => {
	  let mainthis = this;
	  $('#onDemandStream').removeClass('equipmentInstructions').css({'top': '', 'left': ''});
	  $('#agora_local').removeClass('smallerVideo videoMargin');
	  $('#local_preview').removeClass('smallerVideo videoMargin').attr('style', '');
	  $('#agora_local').find('canvas').attr('style', '');
	  $('#canvasWrap').removeClass('smallerVideo').addClass('centerCanvas');
	  $('#setupInstructions').addClass('d-none');
	  $('#footerId').attr('style', 'background: none;');
		
	  $('#movedEquipmentDem').addClass('smallerButton').html('Edit');
	  $('#movedEquipmentTextDem').removeClass('d-none');
	  $('#setupEquipmentHoldDem').addClass('whiteBkg');
	  $('#setupEquipmentHoldDem').removeClass('d-none');
	  $('#setupEquipmentHoldDem').attr('style', 'background-color: #fff !important');
	  $('#movedEquipmentDem').removeClass('d-none');
	  window['showInstructions'] = false;
	  window['hostStartedEquipment'+mainthis.state.currentUserData.id] = true;
	  $('#toolTip').removeClass('d-none');
	  $('#walkToolImageDem').css('background-image', 'url(images/walk.png)');
	  $('#walkToolImageDem').removeClass('d-none');
	  $('.walk_tool_text').html('Walk to the zone');
	  $('.upNext').removeClass('d-none');
	  $('.upNext').html('UP NEXT:');
	  $('#toolTip .part_inner').removeClass('d-none');
	  window['showMessageInstruction'](window['globalEquipmentObject'+mainthis.state.currentUserData.id][window['globalActType']]['fullActName'], false, window['globalEquipmentObject'+mainthis.state.currentUserData.id]['modifyLocation']);
	   
 }
 
 setUpEquipment = () => {
	let mainthis = this;
	$('#toolTip').addClass('d-none');
	$('.participant_stats_hold').addClass('d-none');
	$('#onDemandStream').addClass('equipmentInstructions').offset({ top: 0, left: 0 });
	$('#agora_local').addClass('smallerVideo videoMargin');
	$('#agora_local').find('canvas').attr('style', 'width: 70% !important; height: 80% !important; top: 10% !important; left: 2vw !important; transform: translateX(0%) rotateY(180deg) !important;');
	$('#canvasWrap').addClass('smallerVideo').removeClass('centerCanvas');
	//let paddLeft = $('#canvasWrap').offset().left;
	let paddLeft = 0;
	$('#local_preview').addClass('smallerVideo videoMargin').attr('style', 'width: 70vw !important; max-height: calc(70vw * 9 / 16 ) !important; max-width: calc(80vh * 16 / 9) !important; left: 0 !important;');
	$('#setupInstructions').removeClass('d-none');
	$('#movedEquipmentDem').addClass('d-none');
	$('#setupEquipmentHoldDem').addClass('d-none');
	$('#setupEquipmentHoldDem').attr('style', '');
	$('#footerId').attr('style', 'display: none!important;');
	
	window['showInstructions'] = true;
  }
  
  openCamSettings=()=>{
	  if ($('#change-camera').hasClass('d-none')) {
		  //if( window['ipad'] == undefined ) { getDevices(); }

		  setTimeout( () => {
			  $('#change-camera').removeClass('d-none');
			  $('.click-switch-camera').find('i').addClass('arrow-down').removeClass('arrow-up');
		  }, 100);
	  } else {
		  $('.click-switch-camera').find('i').removeClass('arrow-down').addClass('arrow-up');
		  $('#change-camera').addClass('d-none');
	  }
  }

	endRoomSetup = () => {
		this.setState({roomSetupRunning: false});
		$('.start_room_button_holder ').addClass('d-none');
		this.playPause();
		//window.isPaused = false;
	}
 
	saveBoxJump=(mod, value)=>{
		let userId = this.state.currentUserData.id;
		let mthis = this;
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': this.state.currentUserData.id, 'equipmentStatement': mod, 'value': value  }).then(res => {
			var boxJumpData = res.data.responseData;
			var setBoxJumpSize = boxJumpData['boxJumpSize'] ? boxJumpData['boxJumpSize'] : '';
			if ( !boxJumpData['boxJumpSize'] ) { mthis.saveBoxJump('boxJumpSize', '12x12'); }
			console.log(setBoxJumpSize, 'setBoxJumpSize');
			
			window['boxJumpSize'] = setBoxJumpSize;
			
			if ( setBoxJumpSize == '7x7' ) { window['boxJumpHeight'] = 49; window['boxJumpWidth'] = 49; window['boxJumpHeight'+userId] = 49; window['boxJumpWidth'+userId] = 49; }
			if ( setBoxJumpSize == '10x10' ) { window['boxJumpHeight'] = 70; window['boxJumpWidth'] = 70; window['boxJumpHeight'+userId] = 70; window['boxJumpWidth'+userId] = 70;  }
			if ( setBoxJumpSize == '12x12' ) { window['boxJumpHeight'] = 84; window['boxJumpWidth'] = 84; window['boxJumpHeight'+userId] = 84; window['boxJumpWidth'+userId] = 84;  }
			if ( setBoxJumpSize == '14x14' ) { window['boxJumpHeight'] = 98; window['boxJumpWidth'] = 98; window['boxJumpHeight'+userId] = 98; window['boxJumpWidth'+userId] = 98;  }
			if ( setBoxJumpSize == '16x16' ) { window['boxJumpHeight'] = 112; window['boxJumpWidth'] = 112; window['boxJumpHeight'+userId] = 112; window['boxJumpWidth'+userId] = 112;  }
			
			if ( boxJumpData['workoutConeLocation'] ) { window['workoutConePlacing'+this.state.currentUserData.id] = JSON.parse(boxJumpData['workoutConeLocation']); }
			
		}).catch(err =>{ console.log('err'); });
	}

	roomSetupNextStep=()=>{
		let currentRoomSetupStep = this.state.roomSetupStep;
		let nextRoomSetupStep = this.state.roomSetupStep;
		let nextRoomSetupTitle = this.state.roomSetupTitle;
		let nextRoomSetupText = this.state.roomSetupText;
		let nextRoomSetupButtonText = this.state.roomSetupButtonText;
		let nextRoomSetupImage = this.state.roomSetupImage;
		let innerHoldVar = this.state.innerHold;
		console.log('roomSetupNextStep', nextRoomSetupTitle);
		if ( currentRoomSetupStep == 1 )
			{	
				window.soundPlay.stopAudio();
				window.soundPlay.playAudio('ContinuePlayRoomSetup');
				var mainthis = this;
				var roomSetupTimer = 5;
				setTimeout(function(){
					$('#partCounterNum').text(roomSetupTimer);
					$('#partBigCounter').removeClass('d-none');
					var roomSetupInterval = setInterval(function(){
						console.log('roomSetupTimer', roomSetupTimer);
						roomSetupTimer--;
						$('#partCounterNum').text(roomSetupTimer);
						if ( roomSetupTimer == 0 )
							{
								mainthis.startRoomSetup();
								clearInterval(roomSetupInterval);
								$('#partBigCounter').addClass('d-none');
							}
					}, 1000);
				}, 4000);
			}
		
		if ( this.state.roomSetupButtonText == 'Skip' && this.state.roomSetupSecondButton == 'Retry' )
			{
				window['userWhiteboard'][this.state.currentUserData.id].trackerActions.disableMediaPipe();
				this.showHideRoomSetup(true);
			}
		
		if ( !this.clickedOnSkip && ( this.state.roomSetupTitle == 'Tilt your camera up' || this.state.roomSetupTitle == 'Tilt your camera down') )
			{
				this.clickedOnSkip = true;
				console.log(this.state.roomSetupTitle, 'roomSetupTitle');
				window.finishMediaPipeCalculationInnit();
				
				this.setState({
					roomSetupSecondButton: ''
				});
				
				setTimeout(function(){
					window['usingPose'] = true;
					
				}, 3000);
			}
			
		if ( currentRoomSetupStep < this.state.roomSetupTitleNames.length )
			{	
				nextRoomSetupStep = currentRoomSetupStep+1;
				nextRoomSetupTitle = this.state.roomSetupTitleNames[currentRoomSetupStep];
				nextRoomSetupText = this.state.roomSetupTextNames[currentRoomSetupStep];
				nextRoomSetupButtonText = this.state.roomSetupButtonTextNames[currentRoomSetupStep];
				nextRoomSetupImage = this.state.roomSetupImageNames[currentRoomSetupStep];
				innerHoldVar = this.state.innerHoldSteps[currentRoomSetupStep];
			}
			
		if ( nextRoomSetupStep == this.state.roomSetupTitleNames.length )
			{
				this.showHideRoomSetup(false);
			}
		
		console.log('roomSetupNextStep22', nextRoomSetupTitle);
		this.setState({
			roomSetupStep: nextRoomSetupStep,
			roomSetupTitle: nextRoomSetupTitle,
			roomSetupText: nextRoomSetupText,
			roomSetupButtonText: nextRoomSetupButtonText,
			roomSetupImage: nextRoomSetupImage,
			innerHold: innerHoldVar
		});
	}

	callTiltMessage=(innerText)=>{
		this.setState({
			roomSetupTitle: innerText,
			roomSetupText: '',
			roomSetupButtonText: 'Skip',
			roomSetupImage: '',
			innerHold: ''
		});
	}
	
	showPopupOndemand = () => {
		this.setState({
			setupStepName: 'Room Setup'
		});
	}
	
	showSkipAndRetry=()=>{
		this.setState({
			roomSetupButtonText: 'Skip',
			roomSetupSecondButton: 'Retry'
		});
	}
	
	showHideRoomSetup=(hideMessage)=>{
		this.setState({
			hideRoomSetupMessage: hideMessage
		});
	}

	callMediaTilt=()=>{
		window['usingPose'] = true;
	}

	showSkipAndTryAgain=()=>{
		window['usingPose'] = false;
		this.setState({
			roomSetupButtonText: 'Skip',
			roomSetupSecondButton: 'Try Again'
		});
	}

	tryAgainTilt=()=>{
		window['startTiltTimeout']();
		this.setState({
			roomSetupSecondButton: ''
		});
	}
	
	startPauseVirtual=(scriptName)=>{
		window['usingPose'] = true;
		window['globalScriptDemand'] = scriptName;
		$('#currentWorkout').text('Demo '+ scriptName);

		if ( !window['electron'] || android || ipad13 )
			{
				window['deviceNotSupported'] = true;
				$('#virtualMsg').text('Device Not Supported').removeClass('d-none');
				return false;
			}
			
		if ( !window['hasConeScript'] )
			{
				return false;
			}

		if ( this.state.videosSwapped )
			{
				this.swapVideos();
				this.setState({videosSwapped:false});
			}

		var hostWhiteboardId = this.state.currentUserData.sessionData.hostId != this.state.currentUserData.id ? this.state.currentUserData.sessionData.hostId : parseInt(JSON.stringify(this.state.currentUserData.sessionData.hostId)+'1000');
		window.hostUserId = hostWhiteboardId;
		
		if ( !this.state.hostWhiteboardLoaded )
			{
				this.hostUserWhiteboard = new whiteboard({'user_id': hostWhiteboardId, 'host_virtual_ondemand': true});
				window['userWhiteboard'][hostWhiteboardId] = this.hostUserWhiteboard;
				window['userWhiteboard'][hostWhiteboardId].currentActivityName = scriptName;
				
				this.setState({hostWhiteboardLoaded:true});
			}
		$('#canvasWrap').removeClass('d-none');
		
		this.hideShowFooter(true);
			
		window['userWhiteboard'][hostWhiteboardId].activityStarted(scriptName);
		window.isPaused = false;
		$('.start_room_button_holder').addClass('d-none');
	}
	
	hideShowFooter=(hide)=>{
		if ( hide )
			{	
				$('.w-50').css('opacity', 0);
				$('#footerId').css({'background': 'none', 'pointer-events': 'none'});
				$('#ac_list_pop').css('pointer-events', 'auto');
			}
		else
			{
				$('.w-50').css('opacity', 1);
				$('#footerId').removeAttr('style');
			}
	}
	
	calculatingAR=()=>{
		this.setState({
			hiddenCaluclatingAR: false
		});
	}
	
	disableCalculatingAR=()=>{
		this.setState({
			hiddenCaluclatingAR: true
		});
	}
	
	showRecalibrationPopup=()=>{
		this.setState({
			recalibrationPopup: true
		});
	}
	
	dontShowMessageAgain=()=>{
		this.disableCalculatingAR();
		this.recalibrationPopupAction(true);
	}
	
	recalibrationPopupAction = (mod) => {
		if ( mod )
			{
				localStorage.setItem("recalibrationHidden", true);
				window['disableRecabToggle']();
			}
		else
			{
				localStorage.setItem("recalibrationHidden", false);
			}
		
		this.setState({
			recalibrationPopup: false
		});
	}

render() {

  let sessionData = this.state.currentUserData.sessionData;
  let that = this;
  let isMarketplaceChannel = this.state.currentUserData.isMarketplaceChannel;
  window.startDrawing = this.startDrawing;
  window.closeDrawing = this.closeDrawing;
  window['hideScript'] = hideScript;
  window['playPause'] = this.playPause;
  window['finishHeightOnDemand'] = this.finishHeightOnDemand;
  window['endRoomSetup'] = this.endRoomSetup;
  function hideScript(index){
      if ( that.state.pauseScript === false )
      {
          that.setState({pauseScript: true});
      }

      setTimeout( () => {
        $('#swiper-slide'+(index-1)).remove();
      }, 100);

      setTimeout( () => {
        if (window.mySwiper) { window.mySwiper.update(); }

        let counter = -1;
        $('.swiper-slide').each(function(i, val){          
            if ( $(this).find('.data-slide').length === 1 )
            {
                counter++;
                $(this).find('.data-slide').attr('data-index-counter', counter);
            }
        });
      }, 500);
  }

  

  setTimeout( () => {
      if (this.state.pauseScript === false)
      {
          let counter = -1;
          $('.swiper-slide').each(function(i, val){
              if ( $(this).find('.data-slide').length === 1 )
              {
                  counter++;
                  $(this).attr('data-index-counter', counter);
              }
          });
      }
  }, 3000);

  window['checkActivityType'] = function(ind) {
	if ( !sessionData.scriptDetail[ind] || !sessionData.scriptDetail[ind]['attribute'] || !sessionData.scriptDetail[ind]['attribute'][0] || !sessionData.scriptDetail[ind]['attribute'][0]['attrValue'] ) { return ''; }
	
	return sessionData.scriptDetail[ind]['attribute'][0]['attrValue'];
  }

  return (
    <div className="container d-flex flex-column justify-content-between h-100 position-relative">      
      <header className="header w-100 p-0 header11 header_on_demand">
        <div id="networkmsg" className="screen_popup px-4 py-3 bg-grayy rounded text-white d-none"></div>
        <div className="row">
          <div className="col-lg-12 col-md-12 px-2">
            <div className="transparent-gray transparentt guest-screen">
              <div className="d-flex justify-content-between align-items-top">
                <div className="d-flex pl-2">
                  <div className="count-box position-relative countdown-logo">
                      <img src={sessionData.channelImage != null && sessionData.channelImage != 'default.png' ? sessionData.channelImage : 'images/v-logo.png'} className="logo_icon" />
                      { this.state.currentUserData.isMarketplaceChannel == 0 && 
							<p className="text-center purple_color mb-0 font-12">Powered by Virdio</p>
					  }	
.                  </div>
                  <div className="ml-3 mt-2">
                    <h3 className="main-heading show-hide-title d-block">{sessionData.name}
                      <span className="ml-3">by <span className="welcome-title trim-text onDemandTitleMaxCap">{sessionData.hostFirstName.toLowerCase()} {sessionData.hostLastName.toLowerCase()}</span></span>          
                    </h3>
                  </div>
                </div>
                <div>
                    <div className="justify-content-end d-flex align-items-top mt-1">
                      <span>
                        <button className="ml-2 logout-btn demandlog" onClick={this.onLogoutClick.bind(this)} tabIndex="1"><i className="fa times_demand" aria-hidden="true">&times;</i></button>
                      </span>
                    </div>                  
                  </div>
                </div>
              </div>
            </div>                  
          </div>
      </header>
                    
	  <div className="pre-streaming-counter">
		  <div className="bigCountShow d-none" id="partBigCounter">
	  	      <div className="countNumD2C" id="partCounterNum">0</div>
	  	  </div>
	  </div>
					
      <div className="d-flex main-flex zindex-5 attend-mid-section flex-wrap justify-content-end ondemandmiddlescreen">
          <div className="row">
            <div className="h-100 max-width-300 d-flex heartrateg opacity-zero" id="bpm">
              <div className="left-section heartRate-meter">
                  <ul>
                    <li><div id="hr">-</div><span>HeartRate</span></li>
                    <li><div id="calories">-</div><span>Calories</span></li>
                    <li><div id= "vo2">-</div><span>VO<sub>2</sub>Max</span></li>
                    <li>-<span>Reps</span></li>
                  </ul>
              </div>
            </div>

            <div className={ classnames({'fullVideoBox': true, 'w-90':true}) }>
                <div id="agora_host" style={{ textAlign: "center" }}>
                  <div id="onDemandStream" className="video-streams custom-video-streams noautowidth">
						<span id="workoutAreaButton" className="workoutButton d-none">T <br/> A <br/> P</span>
						<span className="network-text d-none" id="virtualMsg"></span>
						<div id="setupEquipmentHoldDem" className="movedEqButtonHold">
							<div id="movedEquipmentTextDem" className="equipmentSetupText d-none">Equipment is ready</div>
							<div id="movedEquipmentDem" className="equipmentTagsHolderDem d-none" onClick={this.setUpEquipment}>Set up equipment</div>
						</div>
						{  /* <video id="video-element" preload="metadata" playsinline width="100%" height="100%" style={{ position: "absolute", objectFit:"contain", marginLeft:"58px" }} poster={encodeURI(sessionData.image)}>
                      <source src={encodeURI(sessionData.videoPath)} type="video/mp4"></source>
                      Your browser does not support HTML5 video.
					</video> */}
					<div id="canvasWrap" className="canvasHold centerCanvas d-none">
						<span className="d-none">
							<span className="stats_timer_hold">
								<span className="stats_timer_bar"></span>
								<span className="stats_timer"></span>
								<span className="stats_timer_number" id="activityCounter">
									<span className="counter-number">0</span>
								</span>
							</span>
						</span>
						
						<div className="activity_container on_demand_stats d-none" id="participant_activity">
							<div className="top_activity">
								<div className="activity_title" id="currentWorkout"></div>
								<div className="act_stats_container">
									<div className="one_stat d-none" id="virtualPunchHold">
										<div className="heart_icon stats_image" id="repCountImagePar"></div>
										<div className="activity_val" id="repcounter">0</div>
										<div className="activity_type"></div>
									</div>
									<div className="one_stat d-none" id="virtualPunchMinuteHold">
										<div className="heart_icon stats_image reverse_second_image" id="perCountImagePar"></div>
										<div className="activity_val" id="perMinuteCounter">0</div>
										<div className="activity_type" id="nameOfCounter">ppm</div>
									</div>
									<div className="one_stat">
										<div className="heart_icon"></div>
										<div className="activity_val" id="heartrate">0</div>
										<div className="activity_type">hr</div>
									</div>
									<div className="one_stat">
										<div className="fire_icon"></div>
										<div className="activity_val" id="calories">0</div>
										<div className="activity_type">kcal</div>
									</div>
									<div className="one_stat d-none">
										<div className="vo2_icon"></div>
										<div className="activity_val" id="vo2max">0</div>
										<div className="activity_type">V02Max</div>
									</div>
								</div>
							</div>
							<div className="counter_container" id="time_counter">
								<div className="counter_circle" id="workoutTimer">00:00</div>
								<svg className="workout_svg" id="workout_progress" data-role="radial-progress" viewport="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
									<circle r="42" cx="46" cy="45" fill="transparent"></circle>
								</svg>
							</div>
							<div className="counter_container d-none" id="reps_counter">
								<div className="reps_inline">
									<div className="rep_text">REP</div>
									<div className="rep_text" id="repeatNumber"></div>
								</div>
							</div>
						</div>
						
						<div className={classnames("start_room_button_holder", { 'd-none': this.state.setupStepName != 'Room Setup'})}>
							<div className={classnames("room_setup_message_hold inside_session_button", {'d-none': this.state.hideRoomSetupMessage, 'room_setup_message_small': this.state.roomSetupStep != 1, "room_setup_inner_holder": this.state.innerHold})}>
								<div className={classnames("", {'d-none': this.state.roomSetupImage == ''})}>
									<div className={classnames("room_setup_loader", {'d-none': this.state.roomSetupImage != 'room_setup_loader'})}>
									  <div className="room_setup_loader_inner"></div>
									</div>
									<div className={classnames("done_check", {'d-none': this.state.roomSetupImage != 'done_check'})}>
										<svg className="checkmark room_setup_checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg> 
									</div>
								</div>
								<div className={classnames("room_setup_message_title", {'d-none': this.state.roomSetupTitle == '', 'room_setup_smaller_title': this.state.roomSetupStep == 1})}>{this.state.roomSetupTitle}</div>
								<div className={classnames("room_setup_message", {'d-none': this.state.roomSetupText == '', 'room_setup_smaller_text': this.state.roomSetupStep == 1})} dangerouslySetInnerHTML={{__html: this.state.roomSetupText}}></div>
								<div className={classnames("room_setup_message_button_hold", {'d-none': this.state.roomSetupButtonText == '' && this.state.roomSetupSecondButton == ''})}>
									{this.state.roomSetupSecondButton == 'Try Again' &&
											<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupSecondButton == '', 'room_setup_button_small': this.state.roomSetupButtonText !== ''})} onClick={this.tryAgainTilt}>
												{this.state.roomSetupSecondButton}
											</div>
									}
									<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupButtonText == '', 'room_setup_button_small': this.state.roomSetupSecondButton !== ''})} onClick={this.roomSetupNextStep}>
										{this.state.roomSetupButtonText}
									</div>
									{this.state.roomSetupSecondButton == 'Retry' &&
										<div className={classnames("room_setup_message_button", {'d-none': this.state.roomSetupSecondButton == '', 'room_setup_button_small': this.state.roomSetupButtonText !== ''})} onClick={this.retryRoomSetup}>
											{this.state.roomSetupSecondButton}
										</div>
									}
								</div>
							</div>
						</div>
						
						<div className="top_room_setup_bar d-none"></div>
						<div className="bottom_room_setup_bar d-none"></div>
						
						<div id="showCalculatingAR" className={classnames("start_room_button_holder", { 'd-none': this.state.hiddenCaluclatingAR })}>
							<div className="room_setup_message_hold inside_session_button room_setup_message_small">
								<div className="calibration_ar_text">Calibrating</div>
								<div className="calibration_ar_text d-inline-block">AR</div>
								<div className="room_setup_loader">
								  <div className="room_setup_loader_inner"></div>
								</div>
								<div className="calibration_ar_text out_of_frame">Did you step out of frame?</div>
								<div className="calibration_ar_text out_of_frame dont_show_message pointer" onClick={ () => this.dontShowMessageAgain()}>{this.state.dontShowInfo}</div>
							</div>
						</div>
						
						<canvas className="canvasDraw" id="sessionCanvas" width="1280" height="720"></canvas>
						<canvas className="canvasGrid canvasImage" id="imageCanvas" width="1280" height="720"></canvas>
						<canvas className="canvasImage" id="bufferCanvas" width="640" height="360"></canvas>
						<div className="canvasDot" id="editDot"></div>
						<span className="rep-count d-none onDemandCounter" id="repcounter">0</span>
						<span className="rep-count d-none onDemandCounter" id="activityCounter">
							<div className="counter-number">0</div>
						</span>
						<span className="rep-count d-none onDemandCounter2" id="activityName">
							<div className="counter-text act-text"></div>
							<div className="counter-text act-name"></div>
						</span>
						<span id="toolTip" className="hostToolTip screen_popup room_capturing_popup bg-grayy rounded on_demand_tip d-none">
							<span className="separate_stats tool_tip_inner padd3">
								<span className="tooltipSuccess d-none">
									<svg className="checkmark checkmark_inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
										<circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
										<path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
									</svg>
								</span>
								<div className="tooltipImage d-none"></div>
								<span className="upNext d-none">UP NEXT:</span>
								<div className="tooltipText rounded"></div>
								<div id="innerPartText" className="part_inner"></div>
								<div id="walkToolImage" className="walk_tool_hold pointer d-none" onClick={this.roomSetup}>
									<div className="walk_tool_text walk_tool_text_host"></div>
								</div>
								<div id="walkToolImageDem" className="walk_tool_hold d-none">
									<div className="walk_tool_text"></div>
								</div>
								<div className="tooltipNumber d-none"></div>
							</span>
							<span id="progressHostRoom" className="progressHostRoom separate_stats d-none"></span>
						</span>
					</div>
					 <div id="setupInstructions" className="equipmentSetup d-none">
						<div className="setupText">Set up equipment for virtual activity</div>
						<div className="setupInnerText">Click and drag the equipment to the desired location. <br/> Step 2</div>
						<div id="setupButton" className="setupButtonHold pointer" onClick={this.equipmentIsReady}>
							<div className="setupButtonText setupButtonTextHost">Equipment is ready</div>
						</div>
					</div>
					<span id="heightToolTipDem" className="screen_popup room_capturing_popup height_tip d-none"><div id="heightProgressBarDem"><div id="heightProgressDem"></div></div></span>
                  </div>
                  <div className="zoomFullScreen backgroundui d-none" data-toggle="tooltip" title="Expand Instructor Video"></div>
        				  <div className="main_loader d-flex video_behind_loader">
        						<div className="main_loader_inner"></div>
        				  </div>
          
						<div className={ classnames({ 'main_progress_container': true, 'd-none': !this.state.videoDurationCalculated, 'disabled': this.state.roomSetupRunning })}>
							<div className="controls_container_demand">
								{ this.state.pause && <div className="control_icons play_icon" onClick={this.playPause.bind(this)}></div> }
								{ !this.state.pause && <div className="control_icons pause_icon" onClick={this.playPause.bind(this)}></div> }
								<div className="control_icons stop_icon" onClick={this.stopVideo.bind(this)}></div>
								{ !this.state.muted && <div className="control_icons unmute_icon" onClick={this.muteUnmuteVideo.bind(this)}></div> }
								{ this.state.muted && <div className="control_icons mute_icon" onClick={this.muteUnmuteVideo.bind(this)}></div> }
							</div>
							<div className="progress_container" onMouseLeave={this.endSlideIndex}>
								<input type="range" min="0" max="100" defaultValue="0" onChange={this.handleChange} id="progress-bar" step="1" className="progress_main" disabled={this.state.roomSetupRunning} />
							</div>
							<div className="duration_container">
								<span className="duration_video" id="time-elapsed">0:00</span> / <span className="duration_video" id="video-duration">0:00</span>
							</div>
						</div>
						
                  <small className="expand-ondemand d-none">
                      <img src="images/full-screen.png" onClick={this.zoomVideo.bind(this)} />
                  </small>
				  
				  { this.state.showPlayer &&
						<div className="demand_fm_holder">
							<FmPlayer></FmPlayer>
						</div>
				  }
                </div>
            </div>
        </div>
      </div>

        {/*
          {(
            ()=>{
                if(this.state.isScriptAvailable) { 
                    return <LeftScriptParticipant groupId={sessionData.groupId} />;
                }
              }
          )()}
        */}

        <div className="particlecontainer"></div>

        <footer id="footerId" className="footer position-relative zindex-5 count-box mb-lg-2 mt-2 ondemandfooter">
			<div id="change-camera" className="change-camera d-none">
				<div id="selectCameraParticipant">
					<span className="camera-heading text-left">Select a Camera</span>
					<div id="camera-list"></div>
				</div>
				{ window['electron'] &&
					<div className="separator" id="camera-resolutionscheck">
						<span className="camera-heading text-left">Camera Resolution</span>
						<div className="check-camera-resolutions" onClick={() => { this.changeResolutionTo('sd') }}>
							<input type="checkbox" className="form-radio" name="resolutsd" id="resolutsd" value="resolutsd" />
							<label for="resolutsd">SD</label>
						</div>
						<div className="check-camera-resolutions" onClick={() => { this.changeResolutionTo('hd') }}>
							<input type="checkbox" className="form-radio" name="resoluthd" id="resoluthd" value="resoluthd" />
							<label for="resoluthd">HD</label>
						</div>
						<div className="check-camera-resolutions" onClick={() => { this.changeResolutionTo('hdp') }}>
							<input type="checkbox" className="form-radio" name="resoluthdp" id="resoluthdp" value="resoluthdp" />
							<label for="resoluthdp">HD+</label>
						</div>
					</div>
				}
			</div>
			
			<div className="video-holder pos-style mt-3 no_margin_top_zoom">
			  <div className="zoom-box h-100">     
				<div id="agora_local" className={ classnames({'video-streams': true, 'guest-video':true, 'd-none': this.state.hideLocalStream ? true : false}) }>
				{ /*<small className="click-camera click-cam-od backgroundui" data-toggle="tooltip" title="Camera Settings">
                  <img src='images/broadcast.png' />
                </small>
				<small className="click-switch-camera switch-cam-od backgroundui" onClick={this.openCamSettings}>
					<i className="arrow-up" aria-hidden="true"></i>
				</small>*/ }
				<video id="local_preview" autoplay playsinline></video>
				          <span className="hostCamBack d-none" onClick={this.hostCamBack.bind(this)}></span>
                </div>

                {( this.state.streamError === false ) && 
                  <button type="button" className="btn btn-primary hide-preview backgroundui borderui" onClick={this.showHideLocalPreview.bind(this)}>
                    {this.state.hideLocalStream ? 'Show' : 'Hide'}
                    <i className={ classnames({'fa pl-2': true, 'fa-angle-down': this.state.hideLocalStream ? false : true, 'fa-angle-up': this.state.hideLocalStream ? true : false}) } aria-hidden="true"></i>
                  </button>
                }
              </div>       
            </div>

            {(this.state.currentUserData.sessionData.scriptDetail != undefined && this.state.currentUserData.sessionData.scriptDetail.length > 0) &&
              <ActivityList />
            }
            <div className="fitness-emoji d-none">
              <h3>How are you feeling?</h3>
                <div className="d-flex justify-content-between a3">
                  <a href="#" id="like"><img src="./images/like.png" />
                    <span>like</span>
                  </a>
                  <a href="#" id="dislike"><img src="./images/dislike.png" />
                  <span>dislike</span>
                  </a>
                  <a href="#" id="easy"><img src="./images/easy.png" />
                    <span>easy</span>
                  </a>
                  <a href="#" id="too-hard"><img src="./images/too-hard.png" />
                    <span>toohard</span>
                  </a>
                  <a href="#" id="perfect"><img src="./images/perfect.png" />
                    <span>perfect</span>
                  </a>
                  <a href="#" id="awesome"><img src="./images/awesome.png" />
                    <span>awesome</span>
                  </a>
                </div>
            </div>
            
              {(
                ()=>{
                    if(this.state.isScriptAvailable) {
                        return <FooterScriptParticipant groupId={sessionData.groupId} />;
                    }
                  }
              )()}

              <div className="modal attendy-list transpartent_video" id="script-video-popup" data-backdrop="static" data-keyboard="false">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-black transpartent_video border-none">
                      <div className="modal-header border-0 pb-0"></div>
                      <div className="modal-body mt-5">
                        <div style={{ textAlign: "center" }}>
                            <div className="video-streams custom-video-streams noautowidth guest_video_hold activity_video_hold">
                              <div className="main_video_close_hold">
                                  <video id="video_script" playsinline disablePictureInPicture controls controlsList="nodownload" muted autoplay width="100%" height="50%" style={{ position: "absolute", objectFit:"contain", border: "2px solid #bd00ff", outline: "none" }}>
                                    <source src="" type="video/mp4"></source>
                                    Your browser does not support HTML5 video.
                                  </video>

                                  <div className="acitvity_close_button close_video_btn" data-dismiss="modal" aria-label="Close" onClick={this.hideVideoPopup.bind(this)}></div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
			  
          </footer>
		  
		
		<div className="modal bc_black" id="on_demand_failed">
			<div className="modal-dialog failed_center">
			  <div className="modal-content equipmodalbg light_black">
				<div className="modal-header headerborder">
				  <h4 className="modal-title white_clr">On Demand Alert</h4>
				</div>

				<div className="modal-body">
				  <p className="white_clr">
					This On Demand Class is not available anymore.
				  </p>
				</div>
			  </div>
			</div>
		  </div>
		  
		  <SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
      </div>
    );
  }
}

Ondemand.propTypes = {
  auth: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(
  mapStateToProps,
)(Ondemand);
